import Proto from './Proto';

class GoodsHeight extends Proto {
  get infoHeight() {
	const {show_price, show_origin_price, show_buy_btn, show_title, text_align_type} = this.config;
	if (this.config.goods_list_style === 2) return 0;
	let height = 0;
	if (show_title) {
	  height += 40;
	}
	if (text_align_type === "center") {
	  if (show_price || show_origin_price) {
		height += 20;
	  }
	  if (show_buy_btn) {
		height += 35;
	  }
	  if (![0, 40].includes(height)) {
		height += 5;
	  }
	}
	else {
	  if (show_price || show_origin_price || show_buy_btn) {
		height += 40;
	  }
	}

	if (height !== 0) {
	  height += 10;
	}
	return height;
  }
}

export default function ({count, config}) {
  return new GoodsHeight({count, config}).totalHeight;
}
